<template>
  <div>
    <b-form-group
      id="fieldset1"
      description="Let us know your name for the meeting."
      label="Enter your name"
      label-for="input1"
      :invalid-feedback="invalidFeedback"
      :valid-feedback="validFeedback"
      :state="state">
    <b-form-input id="input1" :state="state" v-model.trim="name"></b-form-input>
  </b-form-group>
  <b-btn variant="primary">Join the Meeting</b-btn>
  </div>
</template>
<script>
export default {
  name: 'JoinMeeting',
  data () {
    return {
      id: this.$route.params[0],
      msg: 'hellllooooooo'
    }
  }
}
</script>
<style scoped>
</style>
